import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent, setAnalyticsCollectionEnabled } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions, httpsCallable } from "firebase/functions";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

export const firebaseConfig = {
    apiKey: "AIzaSyBEeickjwf1uDZPpBWblzWWrWFX1y9mtHE",
    authDomain: "primestsky-tabor.firebaseapp.com",
    projectId: "primestsky-tabor",
    storageBucket: "primestsky-tabor.firebasestorage.app",
    messagingSenderId: "1016280519432",
    appId: "1:1016280519432:web:a82a6e9452b5003dfd92bd",
    measurementId: "G-W7MPTEPL5N"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const realtimeDb = getDatabase(app);
export const auth = getAuth(app);

// Storage
export const storage = getStorage(app);

// ANALYTICS
const analytics = getAnalytics(app);
setAnalyticsCollectionEnabled(analytics, true);

export function logAnalytics(name, additional_params = null) {
    if (!additional_params || Object.keys(additional_params).length === 0) {
        logEvent(analytics, name);
    } else {
        logEvent(analytics, name, additional_params);
    }
}

// FUNCTIONS
const functions = getFunctions(app, "europe-west1");

const isFunctionsEmulatorON = true;
if (process.env.NODE_ENV === "development" && isFunctionsEmulatorON) {
    console.log("connectFunctionsEmulator");
    connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}
const callableOptions = {
    //limitedUseAppCheckTokens: true,
};

const initCallFunction = (name, options = {}) =>
    httpsCallable(functions, name, {
        ...callableOptions,
        ...options,
    });

export const onFormSubmitCallable = initCallFunction("onFormSubmit");
export const onKurzFormSubmitCallable = initCallFunction("onKurzFormSubmit");
export const onSendPaidEmailCallable = initCallFunction("onSendPaidEmail");
